import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { DatePicker, Input } from "uxp/components";
import { hasValue } from "../../../../util";
import { CustomColorPicker, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";

interface IDateFieldProperty extends IBaseInputFieldProperty {
	title?: string
	minDate?: string | Date
	maxDate?: string | Date
	fieldLabel:IFieldTitleProps
}

export const Field: React.FunctionComponent<IUIFieldProps<IDateFieldProperty>> = (props) => {
	let { value, onChange, title, minDate, maxDate } = props?.fieldProps || {};

	let styles: React.CSSProperties = {}

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />
			<DatePicker
				title={title || 'Date'}
				date={value || new Date()}
				onChange={onChange}
				options={{
					minDate: minDate,
					maxDate: maxDate
				}}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IDateFieldProperty>> = (props) => {

	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Date Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<DatePicker
					title="Date"
					date={props.uiProps.value || new Date()}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
					showFullMonthName={false}
					hideLabels
					hideInput
					closeOnSelect
				/>
			</Property>

			<Property>
				<PropertyTitle>Title</PropertyTitle>
				<Input
					value={props.uiProps.title || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { title: s }))}
					className="widget-designer-input"
				/>
			</Property>
			

			<Property>
				<PropertyTitle>Min Date</PropertyTitle>
				<DatePicker
					title="Min Date"
					date={props.uiProps.minDate || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { minDate: s }))}
					showFullMonthName={false}
					hideLabels
					hideInput
					closeOnSelect
				/>
			</Property>
			<Property>
				<PropertyTitle>Max Date</PropertyTitle>
				<DatePicker
					title="Max Date"
					date={props.uiProps.maxDate || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { maxDate: s }))}
					showFullMonthName={false}
					hideLabels
					hideInput
					closeOnSelect
				/>
			</Property>

		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>;
}

registerUIField({
	id: 'date',
	category: 'date-time',
	description: 'Date Input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		title: 'Date',
		fieldLabel:{
			label:'Pick a Date',
		}
	},
	type:'date'

});
